module.exports = __webpack_public_path__ + "ejxlicons.729de838d6f98628789f.eot";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/spreadsheet/ejxlicons.eot
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/spreadsheet/ejxlicons.eot
// module chunks = 2